import _ from 'lodash'

export const CLEAR_FILTER = 'CLEAR_FILTER'
export const RESET_FILTER_STATE = 'RESET_FILTER_STATE'
export const UPDATE_FILTER = 'UPDATE_FILTER'
export const UPDATE_MULTIPLE_FILTERS = 'UPDATE_MULTIPLE_FILTERS'
export const UPDATE_EXACT_MATCH_FILTERS = 'UPDATE_EXACT_MATCH_FILTERS'

export const clearAllFilters = () => {
  return dispatch => {
    dispatch({ type: RESET_FILTER_STATE })
  }
}

export const clearFilter = filterKey => {
  return dispatch => {
    dispatch({
      type: CLEAR_FILTER,
      payload: filterKey,
    })
  }
}

export const updateExactMatchFilter = (filterKey, action) => (dispatch, getState) => {
  const exactMatchFilters = _.get(getState(), 'filtersData.matchExactly')
  // action is either _.concat or _.without depending on active state
  const updatedFilters = action(exactMatchFilters, filterKey)
  dispatch({ type: UPDATE_EXACT_MATCH_FILTERS, payload: updatedFilters })
}

export const updateFilter = (filterKey, filters) => {
  return dispatch => {
    dispatch({
      type: UPDATE_FILTER,
      payload: { filterKey, filters },
    })
  }
}

export const updateMultipleFilters = (filters) => {
  return dispatch => {
    dispatch({
      type: UPDATE_MULTIPLE_FILTERS,
      payload: filters,
    })
  }
}
